import { render, staticRenderFns } from "./YouhuiPop.vue?vue&type=template&id=b11b28ec&scoped=true"
import script from "./YouhuiPop.vue?vue&type=script&lang=js"
export * from "./YouhuiPop.vue?vue&type=script&lang=js"
import style0 from "./YouhuiPop.vue?vue&type=style&index=0&id=b11b28ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11b28ec",
  null
  
)

export default component.exports